// extracted by mini-css-extract-plugin
module.exports = {"downloadCSVButton":"styles_downloadCSVButton__5E4da","tableWrapper":"styles_tableWrapper__3O_1f","actions":"styles_actions__3_IhX"};